import { useEffect, useRef } from 'react';
import { FilterOption, FilterOptions } from '@/api';
import { useOpenApi } from '../providers/open-api-provider';
import { TEAM_FILTER_OPTIONS_QUERY_KEY } from './common-query-keys';
import {
    FILTER_OPTIONS_PAGE_SIZE,
    FetchFilterOptionsQuery,
    FetchFilterOptionsResult,
    useFetchFilterOptionsPages
} from './filter-options-paging';

/** The teams a viewer can filter or pick from, searched and paged. */
export function useFetchTeamFilterOptions(
    query: FetchFilterOptionsQuery
): FetchFilterOptionsResult<FilterOption> {
    const { companyId, search, enabled } = query;

    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    return useFetchFilterOptionsPages<FilterOption>(
        [TEAM_FILTER_OPTIONS_QUERY_KEY, { companyId, search }],
        enabled,
        (offset) =>
            openApiRef.current.filters
                .getTeamFilterOptions({
                    companyId,
                    limit: FILTER_OPTIONS_PAGE_SIZE,
                    offset,
                    search: search || undefined
                })
                .then((response): FilterOptions => response.data.data.options)
    );
}
